import { Dialog as PrimeDialog, type DialogProps } from "primereact/dialog";
import { type FC } from "react";

import { useGetElemenetById } from "@ds/hooks/use-get-element-by-id";

export const Dialog: FC<DialogProps> = props => {
  const [element] = useGetElemenetById("app-modals");
  return <PrimeDialog appendTo={element} {...props} />;
};
